function initBusinesses() {
  const businessesTabsSwipers = document.querySelectorAll('.businesses__tabs-swiper');

  businessesTabsSwipers.forEach(swiper => {
    new Swiper(swiper, {
      slidesPerView: 3,
      spaceBetween: 10,

      breakpoints: {
        0: {
          slidesPerView: 1.07,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        1280: {
          slidesPerView: 3,
          spaceBetween: 10,
        }
      }
    });
  });

  const businessesSelectBtn = document.querySelector('.businesses__select-btn');
  const businessesSelectBtnText = document.querySelector('.businesses__select-btn-text');
  const businessesTabsButtons = document.querySelector('.businesses__tabs-buttons');
  let inited = false;

  businessesSelectBtn.addEventListener('click', () => {
    businessesSelectBtn.classList.toggle('is-active');
    businessesTabsButtons.classList.toggle('is-active');
    inited = true;
  });

  document.addEventListener('click', (e) => {
    if (!businessesSelectBtn.contains(e.target)) {
      businessesSelectBtn.classList.remove('is-active');
      businessesTabsButtons.classList.remove('is-active');
    }
  });

  setInterval(() => {
    if (inited) {
      const activeTab = document.querySelector('.businesses__tabs-button.is-active');
      businessesSelectBtnText.textContent = activeTab ? activeTab.textContent : 'Направление';
    }
  }, 10);
}

export {initBusinesses};